import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ChangeDetectionStrategy, Component, Inject, inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { ModalComponent } from "../modal";
import { ShowModalTerminosyCondicionesService } from './services/showModalTerminosyCondiciones.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'show-modal-terminosy-condiciones',
  imports: [CommonModule, ModalComponent, NgxSkeletonLoaderModule],
  templateUrl: './showModalTerminosyCondiciones.html',
  styleUrls: ['./showModalTerminosyCondiciones.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowModalTerminosyCondiciones implements OnInit {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  }
  termsAccepted = signal(false);
  isOpen = signal(false);
  loading = signal(false);
  readonly termsKey = 'termsAndConditions';
  readonly dateFormat = 'dateTerms';
  dateTerms = signal<Date | null>(null);
  dateText = signal('');
  showModalTerminosyCondicionesService = inject(ShowModalTerminosyCondicionesService);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.showModal();
    }
  }

  navigate(url: string, target: string): void {
    window.open(url, target);
  }


  showModal() {
    this.loading.set(true);
    const accepted = localStorage.getItem(this.termsKey) === 'true';
    const acceptedDate = localStorage.getItem(this.dateFormat) || '';
    this.termsAccepted.set(accepted);
    if (!accepted) {
      this.isOpen.set(true);
    }
    this.showModalTerminosyCondicionesService.showModal().pipe(
      finalize(() => this.loading.set(false))
    ).subscribe({
      next: (response) => {
        const raw: any = response.data.created_at;
        let latestDate: Date;
        let latestKey: string;

        if (raw instanceof Date) {
          latestDate = raw;
          latestKey = latestDate.toISOString().slice(0, 10);
        } else if (typeof raw === 'string') {
          const s = raw.trim();
          const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (m) {
            const y = Number(m[1]);
            const mo = Number(m[2]);
            const d = Number(m[3]);
            latestDate = new Date(y, mo - 1, d);
            latestKey = `${m[1]}-${m[2]}-${m[3]}`;
          } else {
            const tryIso = new Date(s.replace(' ', 'T'));
            if (!isNaN(tryIso.getTime())) {
              latestDate = tryIso;
              latestKey = tryIso.toISOString().slice(0, 10);
            } else {
              const now = new Date();
              latestDate = now;
              latestKey = now.toISOString().slice(0, 10);
            }
          }
        } else {
          const now = new Date();
          latestDate = now;
          latestKey = now.toISOString().slice(0, 10);
        }

        this.dateTerms.set(latestDate);
        this.dateText.set(latestDate.toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }));
        const shouldShow = !accepted || acceptedDate !== latestKey;
        if (shouldShow) {
          this.isOpen.set(true);
          if (accepted && acceptedDate !== latestKey) {
            this.termsAccepted.set(false);
            localStorage.removeItem(this.termsKey);
          }
        } else {
          this.isOpen.set(false);
        }
      },
      error: (error) => {
        console.error('Error al obtener los términos y condiciones:', error);
        this.isOpen.set(!accepted);
      }
    });
  }


  closeModal(): void {
    this.isOpen.set(false);

  }
  acceptTerms(checked: boolean): void {
    this.termsAccepted.set(checked);
    if (checked) {
      const dateKey = this.dateTerms()?.toISOString().slice(0, 10) || '';
      localStorage.setItem(this.dateFormat, dateKey);
      localStorage.setItem(this.termsKey, 'true');
      this.isOpen.set(false);
    }
  }

}
